import gql from 'graphql-tag'

export const GET_ORDERFILTER_ENUM = gql`
  query {
    __type(name: "OrderFilterEnum") {
      enumValues {
        description
        name
      }
    }
  }
`
export const GET_ORDERSTATUS_ENUM = gql`
  query {
    __type(name: "OrderStatusEnum") {
      enumValues {
        description
        name
      }
    }
  }
`
export const GET_ORDERCURRENTSTATUSFORM_ENUM = gql`
  query {
    __type(name: "OrderCurrentStateFormEnum") {
      enumValues {
        description
        name
      }
    }
  }
`
export const GET_ORDERDISCOUNTTYPE_ENUM = gql`
  query {
    __type(name: "OrderDiscountTypeEnum") {
      enumValues {
        description
        name
      }
    }
  }
`

export const GET_EXPENSECATEGORY_ENUM = gql`
  query {
    __type(name: "ExpenseCategoryEnum") {
      enumValues {
        description
        name
      }
    }
  }
`

export default {
  GET_ORDERFILTER_ENUM,
  GET_ORDERSTATUS_ENUM,
  GET_ORDERCURRENTSTATUSFORM_ENUM,
  GET_ORDERDISCOUNTTYPE_ENUM,
  GET_EXPENSECATEGORY_ENUM
}
